import { gql } from "@apollo/client";

export const RETRIEVE_RESTAURANT_BY_ID = gql`
    query gqlRetrieveRestaurantById($nID: Int!) {
        data: gqlRetrieveRestaurantById(nID: $nID) {
            nID
            sName
            sCuisine
            sDescription
            sAddress
            sPhone
            sHours
            sImage
            languages
            sLogo
        }
    }
`;

export const RETRIEVE_RESTAURANTS = gql`
    query gqlRetrieveRestaurants {
        data: gqlRetrieveRestaurants {
            nID
            sName
            sCuisine
            sDescription
            sAddress
            sPhone
            sHours
            languages
            sLogo
        }
    }
`;